<template lang="pug">
div
  el-card(shadow="hover").espacamento
    div.cardHeader
      b Dados do Documento:
    div#line
    p(style="color: red; font-size: 13px" v-if="exibeObs") Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI).
    div.center
      el-col(:span='8').flex
        app-display(label="Nome/Razão Social:", :content="cadastro.dados.cadastro.interessado.pessoa.pessoaFisica.nome" :contentAlignRight="false")
        app-display(label="CPF/CNPJ:", :content="cadastro.dados.cadastro.interessado.pessoa.pessoaFisica.cpf" :contentAlignRight="false")
        app-display(label="Endereço:", :content="cadastro.dados.cadastro.interessado.pessoa.endereco.logradouro" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Telefone:", :content="cadastro.dados.cadastro.interessado.pessoa.telefones[0]" :contentAlignRight="false")
        app-display(label="N° Processo:", :content="dadosVtn.processo.numeroProcesso" :contentAlignRight="false")
        app-display(label="Data Emissão:", :content="getDataFrmatada(dadosVtn.dataEmicao)" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Município:", :content="getNomeMunicipio()" :contentAlignRight="false")
        app-display(label="Data Vencimento:", :content="getDataFrmatada(dadosVtn.dataVencimento)" :contentAlignRight="false")
    div.cardHeader
      b Dados dos fatores de redução:
    div#line
    p(style="color: red; font-size: 13px" v-if="exibeObs") Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI).
    div.center
      el-col(:span='8').flex
        app-display(label="Tempo de Ocupação (anos):", :content="dadosVtn.tempoOcupacao" :contentAlignRight="false")
        app-display(label="Eletrificação Rural:", :content="cadastro.dados.cadastro.imovel.possuiEletrificacao ? 'Sim' : 'Não'" :contentAlignRight="false")
        app-display(label="Distância da Capital Boa Vista em Linha Reta (km):", :content="dadosVtn.distanciaBoaVista" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Área Reserva Legal:", :content="areaReservalegalProcentagem" :contentAlignRight="false")
        app-display(label="Acesso por Rodovia RR/BR Pavimentado:", :content="cadastro.dados.cadastro.imovel.possuiAcessoRodovia && cadastro.dados.cadastro.imovel.isRodoviaPavimentada ? 'Sim' : 'Não'" :contentAlignRight="false")
        app-display(label="Interesse Ecológico Para a Preservação dos Ecossistemas:", :content="cadastro.dados.cadastro.imovel.interessesEcologicos ? 'Sim' : 'Não'" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Conduta ou Atividade Lesiva ao Meio Ambiente:", :content="dadosVtn.condutaLesivaMeioAmbiente ? 'Sim' : 'Não'" :contentAlignRight="false")
        app-display(label="Acesso por vicinais:", :content="cadastro.dados.cadastro.imovel.isRodoviaVicinais ? 'Sim' : 'Não'" :contentAlignRight="false")
        app-display(label="Projeto de Recuperação de Áreas Degradadas:", :content="cadastro.dados.cadastro.imovel.possuiProjetoRecuperacao ? 'Sim' : 'Não'" :contentAlignRight="false")
    div.cardHeader
      b Resumo dos dados do cálculo:
    div#line
    p(style="color: red; font-size: 13px" v-if="exibeObs") Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI).
    div.center
      el-col(:span='8').flex
        app-display(label="Somatório dos Fatores de Redução:", :content="getValor(dadosVtn, 'somatorioDosConficientesFormatado')" :contentAlignRight="false")
        app-display(label="Valor do VTN Para Área em Uso:", :content="getValorNumerico(dadosVtn, 'municipio; valorReferencia').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor do VTN Para Área de Reserva Legal:", :content="getValorNumerico(dadosVtn, 'vtnAreaReservaLegal').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor Total do Imóvel:", :content="dadosVtn.valorFinalImovelFormatado" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Porcentagem Máxima Para Redução (%):", :content="getValor(dadosVtn, 'porcentagemMaximaReducaoFormatada')" :contentAlignRight="false")
        app-display(label="VTNt: Para Área em Uso(R$/ha):", :content="getValorNumerico(dadosVtn, 'vtntAreaUso').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="VTNt: Para Área de Reserva Legal(R$/ha)", :content="getValorNumerico(dadosVtn, 'vtntReservaLegal').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor Total do Imóvel a Vista (R$):", :content="dadosVtn.valorAVistaFormatado" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Porcentagem Aplicável Para Redução:", :content="getValor(dadosVtn, 'percentualAplicadoFormatado')" :contentAlignRight="false")
        app-display(label="Valor do Imóvel em Relação a Área em Uso:", :content="getValorNumerico(dadosVtn, 'vtnAreaUso').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor do Imóvel em Relação a Área de Reserva Legal:", :content="getValorNumerico(dadosVtn, 'vtnReservaLegal').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
  observacoesRR.espacamento(v-if="exibeCardObs")
</template>

<script>
import ObservacoesRR from './ObservacoesRR.vue'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  components: {
    AppDisplay,
    AppDivider,
    ObservacoesRR
  },

  props: {
    dadosVtn: {
      type: Object,
      required: true
    },
    cadastro: {
      type: Object,
      required: true
    },
    exibeObs: {
      type: Boolean,
      required: false,
      default: false
    },
    isVisualizar: {
      type: Boolean,
      required: false,
      default: false
    },
    processo: {
      type: Object,
      required: false
    },
    exibeCardObs: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    intervaloPercentual () {
      if (this.dadosVtn.percentualAplicado >= 0.1 && this.dadosVtn.percentualAplicado < 0.3) {
        return 'entre 10% e 30%'
      } else {
        return 'entre 30% e 50%'
      }
    },

    showAnteciparParcelas () {
      return !this.dadosVtn.status.includes('Aguardando validação', 'Criado')
    },

    jurosText () {
      if (this.dadosVtn.percentualAplicado >= 0.1 && this.dadosVtn.percentualAplicado < 0.3) {
        return '3% ao ano + correção monetária'
      } else {
        return '5% ao ano + correção monetária'
      }
    },

    carenciaText () {
      if (this.dadosVtn.percentualAplicado >= 0.1 && this.dadosVtn.percentualAplicado < 0.3) {
        return '3% ao ano após a expedição do Título de Domínio'
      } else {
        return '5% ao ano após a expedição do Título de Domínio'
      }
    },
    areaReservalegalProcentagem () {
      const areaCerrado = this.cadastro.dados.cadastro.imovel.areaReservaLegalCerrado
      const areaFloresta = this.cadastro.dados.cadastro.imovel.areaReservaLegalFloresta
      return ((this.contemValorNumerico(areaCerrado) ? areaCerrado : 0.0) + (this.contemValorNumerico(areaFloresta) ? areaFloresta : 0.0))
    }
  },

  methods: {
    numeroModulosFiscais () {
      return 'Número de Módulos fiscais = Área Requerida / Módulo fiscal do município'
    },

    percentualAplicadoVtn () {
      return '(Coeficiente Angular x  Área requerida) +  Coeficiente Linear =  Percentual a ser aplicado sobre o VTN'
    },

    juros () {
      return 'O valor da correção monetária será atualizado anualmente.'
    },

    antecipacaoParcela () {
      this.$router.push({
        name: 'vtn/antecipacao-parcela',
        params: {
          processo: this.processo
        }
      })
    },
    getDataFrmatada (data) {
      if (!data) {
        return ' - '
      }
      let dia = data[2] < 10 ? '0' + data[2] : data[2]
      let mes = data[1] < 10 ? '0' + data[1] : data[1]
      let ano = data[0]
      return dia + '/' + mes + '/' + ano
    },
    getValorNumerico (value, campo, produto = 1) {
      const campos = campo.split('; ')
      if (campos.length > 1) {
        return value[campos[0]] && value[campos[0]][campos[1]] ? value[campos[0]][campos[1]] * produto : 0
      }
      return value[campo] ? value[campo] * produto : 0
    },
    getValor (object, value) {
      return object[value] ? object[value] : ' - '
    },
    getNomeMunicipio () {
      return this.dadosVtn?.municipio?.nomeComCodigoEstadoFormatado || ' - '
    },
    contemValorNumerico (str) {
      return /[0-9]/.test(str)
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 13%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: inherit;
}

.espacamento {
  margin: 3% 20px 20px 20px;
  border-radius: 10px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/ConfirmarDadosRR.vue